module.exports = __webpack_public_path__ + "img/onboarding-completed-cut.310f9b7c.png";